import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.002 10.1321C17.0015 10.2668 16.9738 10.4001 16.9205 10.5238C16.8672 10.6475 16.7895 10.7592 16.692 10.8521L12.692 14.7121C12.5051 14.8954 12.2538 14.998 11.992 14.998C11.7303 14.998 11.4789 14.8954 11.292 14.7121L7.29202 10.7121C7.19878 10.6189 7.12482 10.5082 7.07436 10.3864C7.0239 10.2646 6.99792 10.134 6.99792 10.0021C6.99792 9.87028 7.0239 9.73971 7.07436 9.61789C7.12482 9.49607 7.19878 9.38538 7.29202 9.29214C7.38526 9.1989 7.49595 9.12494 7.61777 9.07448C7.73959 9.02402 7.87016 8.99805 8.00202 8.99805C8.13388 8.99805 8.26444 9.02402 8.38627 9.07448C8.50809 9.12494 8.61878 9.1989 8.71202 9.29214L12.002 12.5921L15.302 9.41214C15.4894 9.22589 15.7428 9.12135 16.007 9.12135C16.2712 9.12135 16.5247 9.22589 16.712 9.41214C16.8059 9.50677 16.8799 9.61921 16.9297 9.74285C16.9795 9.8665 17.0041 9.99886 17.002 10.1321Z",
		fill: "currentColor"
	})
});
export default SvgIconChevronDown;
